// extracted by mini-css-extract-plugin
export var body = "_m8-8";
export var button = "_m8-0";
export var closeButton = "_m8-5";
export var content = "_m8-3";
export var empty = "_m8-f";
export var grid = "_m8-c";
export var header = "_m8-4";
export var icon = "_m8-1";
export var option = "_m8-d";
export var optionSelected = "_m8-e";
export var overlay = "_m8-2";
export var searchIcon = "_m8-a";
export var searchInput = "_m8-b";
export var searchWrapper = "_m8-9";
export var title = "_m8-6";
export var visuallyHidden = "_m8-7";